import i18n from '~/localization/i18n';

export const extractErrorResponse = error => {
    return error && error.response && error.response.data ? error.response.data : {};
};

export const logInErrorMapper = error => {
    const errors = extractErrorResponse(error) || [];
    const err = errors.length > 0 ? errors[0] : {};

    if (err.description && err.description.startsWith('invalid_username_or_password')) {
        return i18n.t('errors.logInErrorText.invalidCredentials');
    } else if (err.code === 'InactiveUser') {
        return i18n.t('errors.logInErrorText.inactiveUser');
    }
    return i18n.t('errors.logInErrorText.default');
};

export const registerErrorMapper = error => {
    const errors = extractErrorResponse(error);
    const err = errors.length > 0 ? errors[0] : {};

    const passwordErrorMessage = passwordErrorMapper(err.code);
    if (passwordErrorMessage) {
        return passwordErrorMessage;
    }
    if (err.code === 'DuplicateUserName' || err.code === 'DuplicateEmail') {
        return i18n.t('errors.registerErrorText.emailTaken');
    } else if (err.code === 'EmailNotAvailable') {
        return i18n.t('errors.registerErrorText.emailAlreadyInUse');
    }
    return i18n.t('errors.registerErrorText.default');
};

/* Password Reset Error Mapper */
export const passwordResetErrorMapper = error => {
    const errors = extractErrorResponse(error);
    const err = errors instanceof Array && errors.length > 0 ? errors[0] : {};

    const passwordErrorMessage = passwordErrorMapper(err.code);
    if (!passwordErrorMessage) {
        return i18n.t('errors.passwordErrorText.default');
    }
    return passwordErrorMessage;
};

export const recoverErrorMapper = error => {
    const errors = extractErrorResponse(error);
    const err = errors instanceof Array && errors.length > 0 ? errors[0] : {};

    const invalidTokenError = invalidTokenMapper(err.code);
    if (invalidTokenError) {
        return invalidTokenError;
    }
    const passwordErrorMessage = passwordErrorMapper(err.code);
    if (passwordErrorMessage) {
        return passwordErrorMessage;
    }
    if (err.code === 'UserNotFound') {
        return i18n.t('errors.recoverErrorText.userNotFound');
    } else if (err.code === 'UserAlreadyActive') {
        return i18n.t('errors.recoverErrorText.userAlreadyActive');
    } else if (err.code === 'DuplicateEmail' || err.code === 'DuplicateUserName') {
        return i18n.t('errors.recoverErrorText.emailAlreadyInUse');
    } else {
        return i18n.t('errors.recoverErrorText.default');
    }
};

export const passwordErrorMapper = errorCode => {
    if (errorCode === 'PasswordTooShort') {
        return i18n.t('errors.passwordErrorText.passwordTooShort');
    } else if (errorCode === 'PasswordRequiresNonAlphanumeric') {
        return i18n.t('errors.passwordErrorText.requireNonAlphanumeric');
    } else if (errorCode === 'PasswordRequiresUpper') {
        return i18n.t('errors.passwordErrorText.requireUpperCase');
    } else if (errorCode === 'PasswordRequiresLower') {
        return i18n.t('errors.passwordErrorText.requireLowerCase');
    } else if (errorCode === 'PasswordRequiresUniqueChars') {
        return i18n.t('errors.passwordErrorText.requireUniqueChars');
    }
    return null;
};

export const invalidTokenMapper = errorCode => {
    if (errorCode === 'InvalidToken') {
        return i18n.t('errors.invalidTokenText.default');
    }
    return null;
};

/* HELPERS */
export const isInvalidToken = error => {
    const errors = extractErrorResponse(error);
    const err = errors instanceof Array && errors.length > 0 ? errors[0] : {};
    return err.code === 'InvalidToken';
};
